module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-abtest-b9ec5d1007b4c394f2d27e3b72074e06.gif";